import { CSSProperties, FC, ReactNode, RefObject, useCallback, WheelEvent } from "react";
import "./ContainerWithOverlay.css";

interface IContainerWithOverlayProps {
    children: ReactNode;
    onOverlayClick: () => void;
    blackout?: boolean;
    ref?: RefObject<HTMLDivElement>;
    onWheel?: (e: WheelEvent<HTMLDivElement>) => void;
    style?: CSSProperties;
    childrenStyle?: CSSProperties;
}

/**
 * Контейнер с оверлеем
 *
 * @param {ReactNode} children - Дочерние элементы.
 * @param {() => void} onOverlayClick - функция по нажатию на оверлей.
 * @param {boolean} [blackout] - затемнение фона (по умолчанию true)
 * @returns {JSX.Element} JSX-элемент, представляющий компонент контейнера с оверлеем.
 */
const ContainerWithOverlay: FC<IContainerWithOverlayProps> = ({
    children,
    onOverlayClick,
    blackout = true,
    ref,
    onWheel,
    style,
    childrenStyle,
}) => {
    const handleOverlayClick = useCallback(() => {
        onOverlayClick();
    }, [onOverlayClick]);

    const handleChildrenClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
    }, []);

    const handleWheel = useCallback((e: React.WheelEvent<HTMLDivElement>) => {
        onWheel?.(e);
    }, [onWheel]);

    const containerClassName = blackout 
        ? "overlay_container" 
        : "overlay_container_without_background";

    return (
        <div
            onWheel={onWheel ? handleWheel : undefined}
            ref={ref}
            style={style}
            className={containerClassName}
            onClick={handleOverlayClick}
            role="dialog"
            aria-modal="true"
        >
            <div 
                className="overlay_children" 
                onClick={handleChildrenClick} 
                style={childrenStyle}
                role="document"
            >
                {children}
            </div>
        </div>
    );
};

export default ContainerWithOverlay;